import type { FaireProductEntity } from "../../entity_types/product";

export const p_4q4wuu8t3d: FaireProductEntity = {
  token: "p_4q4wuu8t3d",
  type: "product",
  name: "Hot Homo Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/7074f48b297e3b704ec9042681fac5989f2f8895253420fcd2a454aec253c1e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cc079933d1c7be135919e81fa0110d0cc781fb60060da291f7595a04ccbbdc53.jpeg",
    "https://cdn.faire.com/fastly/fd657b4cdb30d1e7685ba098f17bbdde3f261d3d1c4a5e33f77e98883eb8db2c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/420d2f8762cef282451fd5cc7fe35d47b58817f8abd6fdda35c73f3454e5ffa2.jpeg",
    "https://cdn.faire.com/fastly/e1627957ca5f682c245920a97557c5294818a46e2099da1c340a8af7a664970d.jpeg"
  ],
  priceDollars: 6.75,
  description: "Inscribed with a haughty homophone, these bold babies will say it loud and proud, you are a HOT HOMO. High quality gym socks for a high-quality queer, pull em up and they'll stay right where you want them.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:12.477Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
